import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const INITIAL_STATE = {
    rows: [],
    list: [],
    filteredRows: [],
    rowsBackup: [],
    searchText: ''
}

const openingBalanceSearchSlice = createSlice({
    name: 'openingBalanceSearch',
    initialState: INITIAL_STATE,
    reducers: {
        setTRows: (state, action) => {
            const newData = action.payload;
            if (Array.isArray(newData)) {
                console.log(newData);
                state.rows = newData;
            }
        },
        setRowsBackup: (state, action) => {
            const newData = action.payload;
            if (Array.isArray(newData)) {
                console.log(newData);
                state.rowsBackup = newData;
            }
        },
        setList: (state, action) => {
            const newData = action.payload;
            if (Array.isArray(newData)) {
                console.log(newData);
                state.list = newData;
            }
        },
        setfilteredRows: (state, action) => {
            const newData = action.payload;
            if (Array.isArray(newData)) {
                console.log(newData);
                state.filteredRows = newData;
            }
        },
        setSearchText: (state, action) => {
            state.searchText = action.payload
        },
        resetOP: (state) => {
            return { ...INITIAL_STATE };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
    },
})

export const { setTRows, setSearchText, resetOP, setList, setRowsBackup, setfilteredRows } = openingBalanceSearchSlice.actions;
export default openingBalanceSearchSlice.reducer;